module.exports = __webpack_public_path__ + "eb0b2f96e3c3e3deeb2e04555792156c.png";